import styled from '@emotion/styled';
import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;
type Icon = (p: IconProps) => React.ReactElement<SVGSVGElement>;

const Svg = styled.svg`
  circle:first-of-type:hover ~ path:last-of-type {
    filter: saturate(2);
  }
`;

const LinkedIcon: Icon = (props) => (
  <Svg width="48" height="34" viewBox="0 0 48 34">
    <g transform="translate(-263 -695)">
      <circle cx="17" cy="17" r="17" transform="translate(263 695)" fill="#eee" />
      <circle cx="10" cy="10" r="10" transform="translate(291 695)" fill="#deedbf" />
      <path
        d="M311.679,319.463l-6.015,6.015-2.244-2.244a1.062,1.062,0,0,0-1.5,1.5l3,3a1.062,1.062,0,0,0,1.5,0l6.766-6.766a1.062,1.062,0,0,0-1.5-1.5"
        transform="translate(-6.607 381.848)"
        fill="#7bb801"
      />
      <path
        d="M11.436,15.545,8.427,18.552a4.937,4.937,0,0,1-6.982-6.981L5.5,7.517A4.907,4.907,0,0,1,13.388,8.79l-1.327,1.327A3.191,3.191,0,0,0,6.725,8.739v0L2.668,12.795A3.206,3.206,0,0,0,7.2,17.328l2.021-2.02A6.235,6.235,0,0,0,11.436,15.545Zm.134-14.1L8.592,4.427a6.308,6.308,0,0,1,2.211.236L12.8,2.672A3.206,3.206,0,1,1,17.33,7.206L13.3,11.232l0,0a3.214,3.214,0,0,1-4.532,0,3.139,3.139,0,0,1-.8-1.369l-.07.057L6.638,11.182a4.9,4.9,0,0,0,7.888,1.273l4.027-4.026A4.938,4.938,0,0,0,11.57,1.447Z"
        transform="translate(270 702)"
        fill="#7bb801"
      />
    </g>
  </Svg>
);

export default LinkedIcon;
